import { render, staticRenderFns } from "./HeaderCommon.vue?vue&type=template&id=874d4f0a&"
import script from "./HeaderCommon.vue?vue&type=script&lang=js&"
export * from "./HeaderCommon.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderCommon.vue"
export default component.exports